import { Badge } from '@round/whitelabel-ui';
import cn from 'classnames';
import styles from './PurchaseOrderBadge.module.css';
import { creatorbase } from '@round/api';
import { Link } from 'react-router-dom';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';
import { TooltipOnOverflow } from '@round/whitelabel-ui';

type Props = {
    poNumber: string;
    invoiceNumber: string | null;
    invoiceStatus: creatorbase.InvoiceStatus | null;
};

const PurchaseOrderBadge = ({ poNumber, invoiceNumber, invoiceStatus }: Props) => {
    return (
        <Link
            to={`/${CREATORBASE_ROOT_PATH}/finance/purchase-orders/?search=${poNumber}`}
            rel="noopener noreferrer"
            className={styles.link}
            onClick={(e) => e.stopPropagation()}
        >
            <Badge className={cn(styles.badge, { [styles[invoiceStatus?.toLowerCase() ?? '']]: invoiceStatus })}>
                <TooltipOnOverflow tooltip={poNumber}>
                    <span className={styles.poNumber}>{poNumber}</span>
                </TooltipOnOverflow>
                |
                <TooltipOnOverflow tooltip={invoiceNumber}>
                    <span className={cn(styles.invoiceNumber, { [styles.uninvoiced]: !invoiceNumber })}>
                        {invoiceNumber || 'Uninvoiced'}
                    </span>
                </TooltipOnOverflow>
            </Badge>
        </Link>
    );
};

export default PurchaseOrderBadge;
